import styled from "styled-components";

export const MobileAppStyled = styled.div`
    background-color: var(--color-base-secondary);
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
`;

export const MobileContentStyled = styled.div`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    padding: 16px;
    
    margin-bottom: 40px;
`;
